import React, { useEffect, useState } from 'react';
import { HQ } from '../sportConfig';
import { teamMatchState } from './teamMatchState';

export function goalsPerMatch(games, sameTeam) {
  const played = games.filter(game => teamMatchState(game) === 'final' &&
    game.home_goals != null && game.away_goals != null);
  if (!played.length) return null;
  return played.reduce((total, game) => total + Number(sameTeam(game.home_team_id) ? game.home_goals : game.away_goals), 0) / played.length;
}

export default function TeamSeasonMetrics({ simulation, teamId, games, sameTeam, hideResults }) {
  const [attendance, setAttendance] = useState(null);
  useEffect(() => {
    setAttendance(null);
    if (!simulation) return;
    const controller = new AbortController();
    fetch(`${HQ.dataApi}/sportsim/attendance?simulation=${encodeURIComponent(simulation)}`, { signal: controller.signal })
      .then(response => { if (!response.ok) throw new Error(); return response.json(); })
      .then(rows => setAttendance(Array.isArray(rows) ? rows : []))
      .catch(() => {});
    return () => controller.abort();
  }, [simulation, teamId]);
  const average = goalsPerMatch(games, sameTeam);
  const summary = attendance?.find(row => sameTeam(row.team_id));
  const crowd = summary?.average;
  const coverage = summary && (summary.reported_matches == null ? "Officiellt snitt" :
    summary.reported_matches === summary.home_matches ? `${summary.reported_matches} matcher` :
      `${summary.reported_matches} av ${summary.home_matches} matcher`);
  return <>
    <div title={HQ.sport !== 'hockey' ? "Officiellt publiksnitt för säsongens hemmamatcher" : "Publiksnitt för säsongens färdigspelade hemmamatcher med rapporterad publik"}><span>Publiksnitt</span><strong>{crowd != null ? new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 0 }).format(crowd) : '–'}</strong>{crowd != null && <small className="team-page__metric-note">{coverage}</small>}</div>
    <div title="Lagets gjorda mål per spelad match under säsongen"><span>Mål per match</span><strong>{!hideResults && average != null ? new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(average) : '–'}</strong></div>
  </>;
}
